export default __webpack_public_path__ + "static/media/tiger.165dd1be.jpeg";